export const DocumentsLocalModule = {
    code: '45bef4fcb80b00963d73ed10b2e6208c',
    icon: 'book',
    localEnabled: true,
    name: 'Documentos',
    url: '/documents',
    includeInNavigation: true,
};
